import * as server from '../entries/pages/czynnosci-notarialne/_page.server.ts.js';

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/czynnosci-notarialne/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/czynnosci-notarialne/+page.server.ts";
export const imports = ["_app/immutable/nodes/6.J5F24zPa.js","_app/immutable/chunks/yI7QhVT-.js","_app/immutable/chunks/DdBbTIYF.js","_app/immutable/chunks/DwKR0wUy.js","_app/immutable/chunks/DmC62j6_.js","_app/immutable/chunks/Ba75VjKx.js","_app/immutable/chunks/B7lD3_W4.js","_app/immutable/chunks/BT_zozEV.js","_app/immutable/chunks/Bu93Vllf.js"];
export const stylesheets = ["_app/immutable/assets/PageHeadingSection.CpMvHLMT.css"];
export const fonts = [];
